'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var idToString = exports.idToString = function idToString(id) {
  return '' + id;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/idToString.js
// module id = 756
// module chunks = 2 3